import { getPublic } from "./api_helper";

export const checkVAT = async (codeVAT) => {
  try {
    const response = await getPublic(`/common/check-vat/${codeVAT}`);

    const { data: {
      code, data, desc
    } } = response;

    if (code !== '00') {
      return {
        error: desc
      };
    }

    return {
      data: {
        addressVAT: data.address,
        codeVAT: data.id,
        companyNameVAT: data.name,
      }
    }
  } catch (error) {
    return {
      error: error.message
    };
  }
}
